import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { LoginAuthService } from '../../../services/login-auth.service';
import { SessionData } from '../../../interfaces/login-auth.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule
  ],
  templateUrl: './header.html',
  styleUrl: './header.css'
})
export class HeaderComponent implements OnInit {
  public userName: string = '';
  public userRuc: string = '';
  public userType: string = '';
  public isMenuOpen: boolean = false;

  constructor(
    private loginAuthService: LoginAuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadUserData();
  }

  /**
   * Cargar datos del usuario desde la sesión
   */
  private loadUserData(): void {
    const session: SessionData | null = this.loginAuthService.getCurrentSession();

    if (session) {
      this.userName = session.nombreCompleto;
      this.userRuc = session.ruc;
      this.userType = session.tipo;
    }
  }

  /**
   * Toggle del menú de usuario
   */
  toggleUserMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  /**
   * Cerrar sesión
   */
  logout(): void {
    Swal.fire({
      title: '¿Cerrar sesión?',
      text: '¿Estás seguro de que deseas cerrar sesión?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, cerrar sesión',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        // Cerrar sesión
        this.loginAuthService.logout();

        // Mostrar mensaje de despedida
        Swal.fire({
          icon: 'success',
          title: '¡Hasta pronto!',
          text: 'Has cerrado sesión correctamente',
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          // Redirigir al login
          this.router.navigate(['/login']);
        });
      }
    });
  }

  /**
   * Ver perfil (placeholder para futura implementación)
   */
  viewProfile(): void {
    Swal.fire({
      icon: 'info',
      title: 'Perfil de Usuario',
      html: `
        <div style="text-align: left; padding: 10px;">
          <p><strong>Nombre:</strong> ${this.userName}</p>
          <p><strong>RUC:</strong> ${this.userRuc}</p>
          <p><strong>Tipo:</strong> ${this.userType}</p>
        </div>
      `,
      confirmButtonText: 'Cerrar',
      confirmButtonColor: '#3085d6'
    });
  }
}